/* eslint-disable */
import React from 'react';

import { IconPropTypes } from 'ggApp/types/propTypes';

const Telegram = ({ color, size, className }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.9872 3.11211L19.7473 20.2409C19.5499 21.7504 17.8054 22.4947 16.5791 21.5927L11.8017 18.0786L9.97822 20.4579C9.4181 21.1762 8.22714 20.7934 8.19045 19.8833L8.00516 15.286L2.81939 11.4716C1.51905 10.5151 1.82915 8.49161 3.35625 7.96844L20.6715 2.03642C21.3608 1.80027 22.0816 2.38961 21.9872 3.11211ZM19.7951 4.45079L4.00445 9.86049L8.54121 13.1975L17.8397 6.55861L11.111 15.0878L17.7641 19.9816L19.7951 4.45079Z"
            fill="#333333"
        />
    </svg>
);

Telegram.propTypes = {
    ...IconPropTypes,
};

Telegram.defaultProps = {
    color: '#333333',
    size: '24px',
};

export default Telegram;
